import { LinkModal } from 'common/LinkModal/LinkModal'
import { LinkModalProps } from 'common/LinkModal/Types'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { useLinkSelection } from 'common/Prose/Toolbar/hooks/useLinkSelection'
import { observer } from 'mobx-react-lite'
import { useMobileToolbar } from '../../../stores/MobileToolbarStore'
import Styles from './LinkModalWrapper.module.scss'

export const LinkModalWrapper = observer(() => {
  const mobileToolbarStore = useMobileToolbar()
  const editorView = useEditorView()
  const { from, to } = editorView.state.selection
  const selectedText = editorView.state.doc.textBetween(from, to)
  const { turnSelectionIntoLink } = useLinkSelection()

  const onCallback: LinkModalProps['callback'] = ({ link, text }) => {
    turnSelectionIntoLink(link, text)
  }

  const onClose = () => {
    mobileToolbarStore.closeTopTier()
  }

  return (
    <div className={Styles.wrapper}>
      <LinkModal
        initialText={selectedText}
        initialQuery={''}
        callback={onCallback}
        close={onClose}
        suggestRecentlyReadArticle={false}
      />
    </div>
  )
})
